import { useState, useEffect } from 'react';
import { api } from '../../api';
import { liveHeartbeat, WsWarnBadge, useIsMobile, useServerHeartbeats } from '../../utils';

function OsIcon({ os }) {
  const icons = { linux: '🐧', windows: '🪟', macos: '🍎' };
  return <span style={{ marginRight: 4, fontSize: 12 }}>{icons[os] || '💻'}</span>;
}

export function ServersOverviewCard({ userRole }) {
  const isMobile = useIsMobile();
  const [servers, setServers] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showIds, setShowIds] = useState(false);
  const showReseller = userRole === 'admin' || userRole === 'operator';
  const isAdminOrOp = showReseller;
  const heartbeatFeed = useServerHeartbeats();

  useEffect(() => {
    if (userRole === 'client') return;
    api.getServersOverview()
      .then(setServers)
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [userRole]);

  if (userRole === 'client') return null;

  return (
    <div style={{ background: 'var(--surface)', border: '1px solid var(--border)' }}>
      <div style={{ padding: '16px 20px', borderBottom: '1px solid var(--border)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <span style={{ fontFamily: 'var(--mono)', fontSize: 12, letterSpacing: 2, textTransform: 'uppercase', color: 'var(--muted)' }}>
          Servidores {!loading && servers ? `(${servers.length})` : ''}
        </span>
        {isAdminOrOp && (
          <label style={{ fontSize: 12, display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer', color: 'var(--muted)' }}>
            <input
              type="checkbox"
              checked={showIds}
              onChange={e => setShowIds(e.target.checked)}
            />
            Mostrar IDs técnicos (diagnóstico)
          </label>
        )}
      </div>

      {loading ? (
        <div style={{ padding: 20, color: 'var(--muted)', fontSize: 13, fontFamily: 'var(--mono)' }}>Cargando...</div>
      ) : !servers || servers.length === 0 ? (
        <div style={{ padding: 20, color: 'var(--muted)', fontSize: 13, fontFamily: 'var(--mono)' }}>Sin servidores registrados</div>
      ) : isMobile ? (
        <div style={{ padding: '8px 16px', maxHeight: 340, overflowY: 'auto' }}>
          {servers.map(s => {
            const hb = liveHeartbeat(s, heartbeatFeed);
            return (
              <div key={s.id} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '10px 0', borderBottom: '1px solid var(--border)', fontSize: 13 }}>
                <span style={{ display: 'inline-block', width: 8, height: 8, borderRadius: '50%', background: hb.color, flexShrink: 0 }} title={hb.label} />
                {hb.wsWarning && <WsWarnBadge />}
                <OsIcon os={s.os_type} />
                <span style={{ flex: 1, fontWeight: 500, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{s.hostname}</span>
                <span style={{ fontSize: 11, color: 'var(--muted)' }}>{s.client_name}</span>
              </div>
            );
          })}
        </div>
      ) : (
        <div style={{ maxHeight: 340, overflowY: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
            <thead style={{ position: 'sticky', top: 0, background: 'var(--surface)', borderBottom: '1px solid var(--border)', zIndex: 1 }}>
              <tr>
                <th style={{ padding: '8px 12px', textAlign: 'left', width: 20, fontFamily: 'var(--mono)', fontSize: 10, letterSpacing: 2, color: 'var(--muted)' }}></th>
                <th style={{ padding: '8px 12px', textAlign: 'left', fontFamily: 'var(--mono)', fontSize: 10, letterSpacing: 2, textTransform: 'uppercase', color: 'var(--muted)' }}>Servidor</th>
                <th style={{ padding: '8px 12px', textAlign: 'left', fontFamily: 'var(--mono)', fontSize: 10, letterSpacing: 2, textTransform: 'uppercase', color: 'var(--muted)' }}>Cliente</th>
                {showReseller && (
                  <th style={{ padding: '8px 12px', textAlign: 'left', fontFamily: 'var(--mono)', fontSize: 10, letterSpacing: 2, textTransform: 'uppercase', color: 'var(--muted)' }}>Reseller</th>
                )}
                {showIds && isAdminOrOp && (
                  <>
                    <th style={{ padding: '8px 12px', textAlign: 'left', fontFamily: 'var(--mono)', fontSize: 10, letterSpacing: 2, textTransform: 'uppercase', color: 'var(--muted)' }}>Machine ID</th>
                    <th style={{ padding: '8px 12px', textAlign: 'left', fontFamily: 'var(--mono)', fontSize: 10, letterSpacing: 2, textTransform: 'uppercase', color: 'var(--muted)' }}>SMBIOS</th>
                    <th style={{ padding: '8px 12px', textAlign: 'left', fontFamily: 'var(--mono)', fontSize: 10, letterSpacing: 2, textTransform: 'uppercase', color: 'var(--muted)' }}>MAC</th>
                  </>
                )}
              </tr>
            </thead>
            <tbody>
              {servers.map((s, i) => {
                const hb = liveHeartbeat(s, heartbeatFeed);
                return (
                  <tr key={s.id} style={{ borderBottom: i < servers.length - 1 ? '1px solid var(--border)' : 'none' }}
                    onMouseEnter={e => e.currentTarget.style.background = 'rgba(0,212,255,0.03)'}
                    onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                    <td style={{ padding: '8px 12px', whiteSpace: 'nowrap' }}>
                      <span title={hb.label} style={{ display: 'inline-block', width: 8, height: 8, borderRadius: '50%', background: hb.color }} />
                      {hb.wsWarning && <WsWarnBadge />}
                    </td>
                    <td style={{ padding: '8px 12px', fontWeight: 500 }}>
                      <OsIcon os={s.os_type} />{s.hostname}
                    </td>
                    <td style={{ padding: '8px 12px' }}>{s.client_name}</td>
                    {showReseller && (
                      <td style={{ padding: '8px 12px', color: 'var(--muted)' }}>{s.reseller_name || '—'}</td>
                    )}
                    {showIds && isAdminOrOp && (
                      <>
                        <td title={s.machine_id || ''} style={{ padding: '8px 12px', fontFamily: 'var(--mono)', fontSize: 11, color: 'var(--muted)' }}>
                          {s.machine_id ? s.machine_id.substring(0, 8) + '…' : '—'}
                        </td>
                        <td title={s.smbios_uuid || ''} style={{ padding: '8px 12px', fontFamily: 'var(--mono)', fontSize: 11, color: 'var(--muted)' }}>
                          {s.smbios_uuid ? s.smbios_uuid.substring(0, 8) + '…' : '—'}
                        </td>
                        <td style={{ padding: '8px 12px', fontFamily: 'var(--mono)', fontSize: 11, color: 'var(--muted)' }}>
                          {s.primary_mac || '—'}
                        </td>
                      </>
                    )}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
